<template>
  <div>
    <div style="margin-bottom: 10px; display: flex; align-items: center;">
      <el-select 
        v-model="pageSize" 
        placeholder="单页显示条数" 
        style="width: 120px;"
      >
        <el-option label="5条/页" :value="5"></el-option>
        <el-option label="10条/页" :value="10"></el-option>
        <el-option label="15条/页" :value="15"></el-option>
        <el-option label="20条/页" :value="20"></el-option>
        <el-option label="30条/页" :value="30"></el-option>
        <el-option label="40条/页" :value="40"></el-option>
        <el-option label="50条/页" :value="50"></el-option>
      </el-select>
    </div>
    <!-- 打印按钮 -->
    <el-button 
      type="primary" 
      icon="el-icon-printer" 
      @click="handlePrint" 
      style="margin-bottom: 20px;"
    >
      打印全部表单 (共 {{ totalPages }} 页)
    </el-button>

    <!-- 打印内容容器 -->
    <div id="print-container">
      <!-- 模板渲染容器 -->
      <div 
        class="print-template" 
        :style="templateContainerStyle"
        v-if="form.tempItems && form.tempItems.length"
      >
        <!-- 遍历 tempItems 渲染每个元素 -->
        <div 
          v-for="(item, index) in form.tempItems" 
          :key="item.uuid || index"
          :class="['template-item', 'item-' + item.type]"
          :style="getItemStyle(item)"
        >
          <!-- 文本类型元素 -->
          <template v-if="item.type === 'braid-txt'">
            <div v-html="getTextContent(item)" class="text-content"></div>
          </template>

          <!-- 表格类型元素 -->
          <template v-if="item.type === 'braid-table'">
            <div class="table-wrapper">
              <table class="detail-table">
                <thead>
                  <tr>
                    <th v-for="col in columns" :key="col.name" :style="getPreviewColumnStyle(col)">
                      {{ col.title }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- 数据行 -->
                  <tr v-for="(row, rowIndex) in product" :key="rowIndex">
                    <td v-for="col in columns" :key="col.name" :style="getPreviewColumnStyle(col)">
                      {{ getCellValue(row, col.name) }}
                    </td>
                  </tr>
                  <!-- 合计行 -->
                  <tr v-if="showSummary" class="total-row">
                    <td :colspan="summaryColspan" style="text-align: center;">
                      {{ summaryText }}
                    </td>
                    <!-- 数量列 -->
                    <td v-if="hasQuantityColumn">{{ quantitySummaryText }}</td>
                    <!-- 数量列和金额列之间的填充 -->
                    <td v-for="n in betweenColumns" :key="'between-' + n"></td>
                    <!-- 金额列 -->
                    <td v-if="hasAmountColumn">{{ amountSummaryText }}</td>
                    <!-- 金额列之后的填充 -->
                    <td v-for="n in afterAmountColumns" :key="'after-amt-' + n"></td>
                  </tr>
                  <!-- 整单优惠行 -->
                  <tr v-if="showSummary && (hasAmountColumn || hasQuantityColumn)" class="discount-row">
                    <td :colspan="summaryColspan" style="text-align: center;">
                      整单优惠：
                    </td>
                    <!-- 数量列 -->
                    <td v-if="hasQuantityColumn"></td>
                    <!-- 数量列和金额列之间的填充 -->
                    <td v-for="n in betweenColumns" :key="'discount-between-' + n"></td>
                    <!-- 金额列显示优惠金额 -->
                    <td v-if="hasAmountColumn" style="color: red;">-{{ wholeDiscount }}</td>
                    <!-- 金额列之后的填充 -->
                    <td v-for="n in afterAmountColumns" :key="'discount-after-amt-' + n"></td>
                  </tr>
                  <!-- 实际支付行 -->
                  <tr v-if="showSummary && (hasAmountColumn || hasQuantityColumn)" class="payment-row" style="font-weight: bold;">
                    <td :colspan="summaryColspan" style="text-align: center;">
                      实际支付：
                    </td>
                    <!-- 数量列 -->
                    <td v-if="hasQuantityColumn"></td>
                    <!-- 数量列和金额列之间的填充 -->
                    <td v-for="n in betweenColumns" :key="'payment-between-' + n"></td>
                    <!-- 金额列显示实际支付金额 -->
                    <td v-if="hasAmountColumn">{{ actualPayment }}</td>
                    <!-- 金额列之后的填充 -->
                    <td v-for="n in afterAmountColumns" :key="'payment-after-amt-' + n"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
      </div>

      <!-- 加载提示 -->
      <div v-else class="loading-container">
        <i class="el-icon-loading"></i>
        <span>加载模板中...</span>
      </div>
    </div>
  </div>
</template>

<script>
import Print_tempApi from '@/api/print_temp.js';
import DdeliveryApi from '@/api/ddelivery.js';

export default {
  name: 'PrintForm',
  data() {
    return {
      form: {
        all_num: '',
        all_price: '',
        amout_num:'',
        amout_money:'',
        tempItems: [],
        width: 750,
        height: 550
      },
      address: '',
      company_address: '',
      customer_name: '',
      complaint_phone: '',
      phone: '',
      order_code: '',
      order_date: '',
      product: [],
      print_temp_id: 0,
      curPage: 10,
      formInline: {
        store_id: 0,
        id: 0
      },
      tableData: [],
      tableTitle:[],
      pageSize: 5, // 单页最大商品数
      paginatedData: [], // 拆分后的多页数据
      quantityColumnIndex: -1, // 数量列索引
      amountColumnIndex: -1,   // 金额列索引
      wholeDiscount: 0, // 整单优惠
      actualPayment: 0, // 实际支付
      columns: [] // 表头列数据
    };
  },
  computed: {
    // 模板容器样式
    templateContainerStyle() {
      return {
        width: this.form.width + 'px',
        height: this.form.height + 'px',
        margin: '0 auto',
        position: 'relative',
        border: '1px dashed #ccc',
        padding: '20px'
      };
    },
    // 拆分商品数据为多页
    splitProductData() {
      const result = [];
      const total = this.product.length;
      if (total === 0) return result;
      
      // 按pageSize拆分数组
      for (let i = 0; i < total; i += this.pageSize) {
        result.push(this.product.slice(i, i + this.pageSize));
      }
      return result;
    },
    // 计算总页数
    totalPages() {
      return this.splitProductData.length;
    },
    // 检测表头是否有金额列
    hasAmountColumn() {
      return this.amountColumnIndex !== -1;
    },
    // 检测表头是否有数量列
    hasQuantityColumn() {
      return this.quantityColumnIndex !== -1;
    },
    // 获取数量列名
    quantityColumnName() {
      if (this.quantityColumnIndex !== -1 && this.columns) {
        return this.columns[this.quantityColumnIndex].name;
      }
      return null;
    },
    // 获取金额列名
    amountColumnName() {
      if (this.amountColumnIndex !== -1 && this.columns) {
        return this.columns[this.amountColumnIndex].name;
      }
      return null;
    },
    // 自动计算合计值
    calculatedTotals() {
      const totals = {
        quantityTotal: 0,
        amountTotal: 0
      };
      
      if (this.product && this.product.length > 0) {
        // 计算数量合计
        if (this.quantityColumnName) {
          totals.quantityTotal = this.product.reduce((sum, item) => {
            return sum + (parseFloat(item[this.quantityColumnName]) || 0);
          }, 0);
        }
        
        // 计算金额合计
        if (this.amountColumnName) {
          totals.amountTotal = this.product.reduce((sum, item) => {
            return sum + (parseFloat(item[this.amountColumnName]) || 0);
          }, 0);
        }
      }
      
      return {
        quantityTotal: totals.quantityTotal.toFixed(0),
        amountTotal: totals.amountTotal.toFixed(2)
      };
    },
    // 是否显示合计
    showSummary() {
      return (this.hasAmountColumn || this.hasQuantityColumn) && 
             this.product && this.product.length > 0;
    },
    // 合计文本 - 有金额就显示金额，没有就显示数量
    summaryText() {
      if (this.hasAmountColumn) {
        return '合计金额：'+this.form.amout_money;
      } else if (this.hasQuantityColumn) {
        return '合计数量：'+this.form.amout_num;
      }
      return '';
    },
    // 数量合计文本
    quantitySummaryText() {
      return this.hasQuantityColumn ? this.calculatedTotals.quantityTotal: '';
    },
    // 金额合计文本
    amountSummaryText() {
      return this.hasAmountColumn ? this.calculatedTotals.amountTotal : '';
    },
    // 数量列和金额列之间的填充列数
    betweenColumns() {
      if (!this.hasQuantityColumn || !this.hasAmountColumn) return 0;
      return Math.max(0, this.amountColumnIndex - this.quantityColumnIndex - 1);
    },
    // 金额列之后的填充列数
    afterAmountColumns() {
      if (!this.columns) return 0;
      if (!this.hasAmountColumn) {
        // 如果没有金额列，但有数量列，则计算数量列之后的列数
        if (this.hasQuantityColumn) {
          return Math.max(0, this.columns.length - this.quantityColumnIndex - 1);
        }
        return 0;
      }
      return Math.max(0, this.columns.length - this.amountColumnIndex - 1);
    },
    // 合计行colspan - 第一个单元格的跨列数
    summaryColspan() {
      if (!this.columns) return 1;
      
      // 如果有数量列，第一个单元格跨列到数量列之前
      if (this.hasQuantityColumn) {
        return this.quantityColumnIndex;
      }
      // 如果没有数量列但有金额列，第一个单元格跨列到金额列之前
      else if (this.hasAmountColumn) {
        return this.amountColumnIndex;
      }
      // 如果都没有，跨所有列
      else {
        return this.columns.length;
      }
    }
  },
  watch: {
    // 监听商品数据变化，自动拆分
    product: {
      deep: true,
      handler() {
        this.paginatedData = this.splitProductData;
      }
    },
    // 监听分页大小变化，重新拆分
    pageSize() {
      this.paginatedData = this.splitProductData;
    },
    // 监听columns变化，检测列位置
    columns: {
      deep: true,
      handler(newColumns) {
        this.detectColumnPositions(newColumns);
      }
    }
  },
  created() {
    this.formInline.id = this.$route.query.id || 0;
    this.print_temp_id = this.$route.query.print_temp_id || 0; 
    this.getData();
    this.getTableList();
  },
  methods: {
    // 获取单元格值
    getCellValue(row, columnName) {
      const value = row[columnName] || '';
      
      // 如果是数量、单价、金额等字段，格式化为数字
      if (['set_num', 'product_price','amount'].includes(columnName)) {
        const num = parseFloat(value);
        return isNaN(num) ? '' : num.toFixed(2);
      }
      
      return value;
    },
    
    // 检测列位置
    detectColumnPositions(columns) {
      if (!columns || !Array.isArray(columns)) return;
      
      // 重置索引
      this.quantityColumnIndex = -1;
      this.amountColumnIndex = -1;
      
      // 遍历columns检测列位置
      columns.forEach((col, index) => {
        const title = col.title || '';
        
        // 检测数量列
        if (title.includes('数量')) {
          this.quantityColumnIndex = index;
        }
        
        // 检测金额列
        if (title.includes('金额')) {
          this.amountColumnIndex = index;
        }
      });
    },
    
    // 获取模板数据
    getData() {
      const self = this;
      Print_tempApi.detail({ print_temp_id: self.print_temp_id }, true)
        .then(function(res) {
          self.form = res.data;
          // 设置正确的宽度和高度
          self.form.width = res.data.width || 600;
          self.form.height = res.data.height || 860;
          
          self.tableTitle = res.data.tempItems.filter(item => item.type === 'braid-table');
          if (self.tableTitle.length > 0) {
            self.columns = self.tableTitle[0].columns;
            // 检测列位置
            self.detectColumnPositions(self.columns);
          }
        })
        .catch(function(error) {
          console.error('获取模板失败', error);
        });
    },
    
    // 解析文本内容
    getTextContent(item) {
      const self = this;
      let content = item.value || item.defaultValue;
      
      // 动态内容替换
      const replacements = {
        '单据日期': self.order_date,
        '单据编号': self.order_code,
        '客户名称': self.customer_name,
        '客户地址': self.address,
        '联系电话': self.phone,
        '公司地址': self.company_address,
        '整单优惠': self.wholeDiscount,
        '实收金额': self.actualPayment
      };
      
      // 执行替换
      for (const [key, value] of Object.entries(replacements)) {
        const regex = new RegExp(`{${key}}`, 'g');
        content = content.replace(regex, value);
        
        // 同时替换带冒号的形式
        const regexWithColon = new RegExp(`${key}:`, 'g');
        content = content.replace(regexWithColon, `${key}: ${value}`);
      }
      
      return content;
    },
    
    // 获取业务数据
    getTableList() {
      const self = this;
      const params = Object.assign({}, self.formInline, { page: self.curPage });
      
      DdeliveryApi.listp(params, true)
        .then(function(data) {
          self.tableData = data.data;
          
          if (self.tableData.length > 0) {
            const mainData = self.tableData[0];
            self.product = mainData.data || [];
            self.form.all_num = mainData.all_num;
            self.form.all_price = mainData.all_price;
            self.form.amout_money = mainData.amout_money;
            self.form.amout_num = mainData.amout_num;
            
            // 更新动态数据
            self.address = mainData.address;
            self.company_address = mainData.company_address;
            self.customer_name = mainData.customer_name;
            self.complaint_phone = mainData.complaint_phone;
            self.order_code = mainData.order_code;
            self.order_date = mainData.order_date;
            self.phone = mainData.phone;
            
            // 计算整单优惠和实际支付
            self.calculatePaymentInfo();
          }
        })
        .catch(function(error) {
          console.error('获取业务数据失败', error);
        });
    },
    
    // 计算整单优惠和实际支付
    calculatePaymentInfo() {
      if (!this.product || this.product.length === 0) return;
      
      // 计算商品原价合计
      const originalTotal = this.product.reduce((sum, item) => {
        return sum + (parseFloat(item.total_price) || 0);
      }, 0);
      
      // 计算优惠合计（会员折扣+优惠券+收银台优惠）
      const discountTotal = this.product.reduce((sum, item) => {
        const gradeDiscount = parseFloat(item.grade_total_money) || 0;
        const couponDiscount = parseFloat(item.coupon_money) || 0;
        const cashdeskDiscount = parseFloat(item.cashdesk_money) || 0;
        return sum + gradeDiscount + couponDiscount + cashdeskDiscount;
      }, 0);
      
      // 计算实付金额合计
      const actualTotal = this.product.reduce((sum, item) => {
        return sum + (parseFloat(item.total_pay_price) || 0);
      }, 0);
      
      this.wholeDiscount = discountTotal.toFixed(2);
      this.actualPayment = actualTotal.toFixed(2);
    },
    
    // 获取元素样式
    getItemStyle(item) {
      const itemStyle = item.style || {};
      return {
        position: 'absolute',
        left: item.left + 'px',
        top: item.top + 'px',
        width: item.width + 'px',
        height: item.height + 'px',
        fontSize: (itemStyle.FontSize || 12) + 'px',
        color: itemStyle.FontColor || '#000',
        fontWeight: itemStyle.Bold ? 'bold' : 'normal',
        fontStyle: itemStyle.Italic ? 'italic' : 'normal',
        textDecoration: itemStyle.Underline ? 'underline' : 'none',
        textAlign: itemStyle.Alignment || 'left',
        zIndex: itemStyle.zIndex || 0,
        overflow: 'hidden',
        boxSizing: 'border-box'
      };
    },
    
    // 获取预览列样式（只在预览时应用）
    getPreviewColumnStyle(col) {
      const colIndex = this.columns ? this.columns.findIndex(c => c.name === col.name) : -1;
      
      // 基础样式
      const baseStyle = {
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        textAlign: 'center'
      };
      
      // 根据列标题设置不同的宽度（只在预览时）
      if (colIndex !== -1) {
        const title = col.title || '';
        
        // 商品名称列 - 给更多宽度
        if (title.includes('商品全名') || title.includes('产品名称')) {
          return {
            ...baseStyle,
            width: '150px',
            minWidth: '150px',
            maxWidth: '150px',
            textAlign: 'left'
          };
        }
        
        // 规格列
        if (title.includes('规格') || title.includes('型号')) {
          return {
            ...baseStyle,
            width: '80px',
            minWidth: '80px',
            maxWidth: '80px'
          };
        }
        
        // 商品编号列
        if (title.includes('商品编号') || title.includes('产品编号')) {
          return {
            ...baseStyle,
            width: '80px',
            minWidth: '80px',
            maxWidth: '80px'
          };
        }
        
        // 单位列
        if (title.includes('单位')) {
          return {
            ...baseStyle,
            width: '50px',
            minWidth: '50px',
            maxWidth: '50px'
          };
        }
        
        // 数量列
        if (title.includes('数量')) {
          return {
            ...baseStyle,
            width: '50px',
            minWidth: '50px',
            maxWidth: '50px'
          };
        }
        
        // 单价、金额列
        if (title.includes('单价') || title.includes('金额') || title.includes('折扣') || title.includes('小计')) {
          return {
            ...baseStyle,
            width: '70px',
            minWidth: '70px',
            maxWidth: '70px'
          };
        }
        
        // 备注列 - 给适当宽度
        if (title.includes('备注')) {
          return {
            ...baseStyle,
            width: '100px',
            minWidth: '100px',
            maxWidth: '100px',
            textAlign: 'left'
          };
        }
        
        // 行号列
        if (title.includes('行号')) {
          return {
            ...baseStyle,
            width: '40px',
            minWidth: '40px',
            maxWidth: '40px'
          };
        }
      }
      
      // 默认样式
      return {
        ...baseStyle,
        width: '80px',
        minWidth: '80px',
        maxWidth: '80px'
      };
    },
    
    // 打印功能 - 重新设计打印样式
    handlePrint() {
      if (this.product.length === 0) {
        this.$message.warning('没有可打印的数据');
        return;
      }

      // 创建打印窗口
      const printWindow = window.open('', '_blank');
      const printDoc = printWindow.document;
      
      // 计算列数
      const columnCount = this.columns.length;
      
      // 计算每列的宽度百分比 - 均匀分布
      const columnWidthPercent = Math.floor(100 / columnCount) + '%';
      
      // 创建打印内容
      let printHTML = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <title>打印单据 - 共 ${this.totalPages} 页</title>
          <style>
            /* 重置所有样式 */
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            
            body {
              font-family: "SimSun", "宋体", Arial, sans-serif;
              font-size: 10px !important; /* 更小的字体 */
              line-height: 1.2;
              color: #000;
              width: 100%;
              max-width: 100%;
              margin: 0;
              padding: 0;
            }
            
            /* 打印设置 */
            @page {
              size: auto;
              margin: 5mm 3mm; /* 最小边距 */
            }
            
            /* 隐藏打印时不显示的元素 */
            .no-print {
              display: none !important;
            }
            
            /* 页面容器 */
            .print-page {
              width: 100%;
              max-width: 100%;
              min-height: 100vh;
              padding: 5mm;
              page-break-inside: avoid;
              overflow: visible !important;
            }
            
            /* 标题区域 */
            .print-header {
              text-align: center;
              margin-bottom: 8px;
              padding-bottom: 5px;
            }
            
            .print-title {
              font-size: 16px;
              font-weight: bold;
              margin-bottom: 3px;
            }
            
            .print-info {
              font-size: 9px;
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;
            }
            
            .print-info-item {
              margin: 1px 0;
              white-space: nowrap;
            }
            
            /* 表格样式 - 关键部分 */
            .print-table-container {
              width: 100%;
              max-width: 100%;
              margin-top: 5px;
              overflow: visible !important;
            }
            
            .print-table {
              width: 100% !important;
              max-width: 100% !important;
              border-collapse: collapse;
              table-layout: fixed !important; /* 使用固定布局 */
              word-wrap: break-word;
              word-break: break-all;
              font-size: 9px !important; /* 更小的字体 */
            }
            
            .print-table th,
            .print-table td {
              border: 1px solid #000 !important;
              padding: 2px 3px !important; /* 最小内边距 */
              text-align: center;
              vertical-align: middle;
              word-break: break-all !important; /* 强制断词 */
              overflow-wrap: break-word !important;
              white-space: normal !important; /* 允许换行 */
              line-height: 1.1;
              font-size: 8px !important; /* 更小的字体 */
            }
            
            /* 商品名称和备注列特殊处理 */
            .print-table .product-name-col,
            .print-table .remarks-col {
              text-align: left !important;
              min-width: 100px !important;
              max-width: 150px !important;
            }
            
            /* 表头样式 */
            .print-table th {
              background-color: #f5f5f5 !important;
              font-weight: bold;
              padding: 3px 4px !important;
            }
            
            /* 合计行 */
            .print-table .total-row {
              font-weight: bold;
              background-color: #f0f0f0 !important;
            }
            
            /* 整单优惠行 */
            .print-table .discount-row {
              font-size: 9px !important;
            }
            
            /* 实际支付行 */
            .print-table .payment-row {
              font-size: 10px !important;
              font-weight: bold !important;
              background-color: #f8f8f8 !important;
            }
            
            /* 页码 */
            .print-footer {
              text-align: right;
              margin-top: 10px;
              font-size: 8px;
              color: #666;
            }
            
            /* 强制分页 */
            .page-break {
              page-break-before: always;
            }
            
            /* 确保内容不溢出 */
            .content-wrap {
              word-break: break-all !important;
              overflow-wrap: break-word !important;
              max-width: 100% !important;
            }
            
            /* 调整列宽，确保所有列都能显示 */
            .col-1 { width: 5% !important; }
            .col-2 { width: 20% !important; } /* 商品名称更宽 */
            .col-3 { width: 8% !important; }
            .col-4 { width: 8% !important; }
            .col-5 { width: 5% !important; }
            .col-6 { width: 5% !important; }
            .col-7 { width: 8% !important; }
            .col-8 { width: 8% !important; }
            .col-9 { width: 8% !important; }
            .col-10 { width: 15% !important; } /* 备注列更宽 */
            
          </style>
        </head>
        <body>
      `;

      // 遍历分页数据，生成多页内容
      this.paginatedData.forEach((pageData, pageIndex) => {
        printHTML += `
          <div class="print-page ${pageIndex > 0 ? 'page-break' : ''}">
            <!-- 标题和信息区域 -->
            <div class="print-header">
              <div class="print-title">${this.form.title || '销售货单'}</div>
              <div class="print-info">
                <div class="print-info-item">单据日期: ${this.order_date || ''}</div>
                <div class="print-info-item">单据编号: ${this.order_code || ''}</div>
                <div class="print-info-item">客户名称: ${this.customer_name || ''}</div>
                <div class="print-info-item">联系电话: ${this.phone || ''}</div>
                <div class="print-info-item">客户地址: ${this.address || ''}</div>
              </div>
            </div>
            
            <!-- 表格区域 -->
            <div class="print-table-container">
              <table class="print-table">
                <thead>
                  <tr>
        `;
        
        // 表头
        this.columns.forEach((col, colIndex) => {
          const colClass = `col-${colIndex + 1}`;
          const isProductName = col.title.includes('商品全名') || col.title.includes('产品名称');
          const isRemarks = col.title.includes('备注');
          const cellClass = isProductName ? 'product-name-col' : (isRemarks ? 'remarks-col' : '');
          
          printHTML += `
            <th class="${colClass} ${cellClass}" style="width: ${columnWidthPercent}">
              ${col.title}
            </th>
          `;
        });
        
        printHTML += `
                  </tr>
                </thead>
                <tbody>
        `;
        
        // 表格数据行
        pageData.forEach((row, rowIndex) => {
          printHTML += `<tr>`;
          
          this.columns.forEach((col, colIndex) => {
            const colClass = `col-${colIndex + 1}`;
            const isProductName = col.title.includes('商品全名') || col.title.includes('产品名称');
            const isRemarks = col.title.includes('备注');
            const cellClass = isProductName ? 'product-name-col' : (isRemarks ? 'remarks-col' : '');
            const cellValue = this.getCellValue(row, col.name);
            
            printHTML += `
              <td class="${colClass} ${cellClass} content-wrap" style="width: ${columnWidthPercent}">
                ${cellValue}
              </td>
            `;
          });
          
          printHTML += `</tr>`;
        });
        
        // 合计行（只在最后一页）
        if (pageIndex === this.paginatedData.length - 1 && this.showSummary) {
          printHTML += `
            <tr class="total-row">
              <td colspan="${this.summaryColspan}" style="text-align: center;">
                ${this.summaryText}
              </td>
          `;
          
          // 数量列
          if (this.hasQuantityColumn) {
            printHTML += `<td style="text-align: center;">${this.quantitySummaryText}</td>`;
          }
          
          // 数量列和金额列之间的填充
          for (let i = 0; i < this.betweenColumns; i++) {
            printHTML += `<td></td>`;
          }
          
          // 金额列
          if (this.hasAmountColumn) {
            printHTML += `<td style="text-align: center;">${this.amountSummaryText}</td>`;
          }
          
          // 金额列之后的填充
          for (let i = 0; i < this.afterAmountColumns; i++) {
            printHTML += `<td></td>`;
          }
          
          printHTML += `</tr>`;
          
          // 整单优惠行
          if (this.hasAmountColumn || this.hasQuantityColumn) {
            printHTML += `
              <tr class="discount-row">
                <td colspan="${this.summaryColspan}" style="text-align: center;">
                  整单优惠：
                </td>
            `;
            
            // 如果有序号列，需要对齐到金额列
            if (this.hasQuantityColumn) {
              printHTML += `<td style="text-align: center;"></td>`;
            }
            
            // 数量列和金额列之间的填充
            for (let i = 0; i < this.betweenColumns; i++) {
              printHTML += `<td></td>`;
            }
            
            // 金额列显示优惠金额（负数）
            if (this.hasAmountColumn) {
              printHTML += `<td style="text-align: center; color: red;">-${this.wholeDiscount}</td>`;
            }
            
            // 金额列之后的填充
            for (let i = 0; i < this.afterAmountColumns; i++) {
              printHTML += `<td></td>`;
            }
            
            printHTML += `</tr>`;
            
            // 实际支付行
            printHTML += `
              <tr class="payment-row">
                <td colspan="${this.summaryColspan}" style="text-align: center;">
                  实际支付：
                </td>
            `;
            
            // 如果有序号列，需要对齐到金额列
            if (this.hasQuantityColumn) {
              printHTML += `<td style="text-align: center;"></td>`;
            }
            
            // 数量列和金额列之间的填充
            for (let i = 0; i < this.betweenColumns; i++) {
              printHTML += `<td></td>`;
            }
            
            // 金额列显示实际支付金额
            if (this.hasAmountColumn) {
              printHTML += `<td style="text-align: center;">${this.actualPayment}</td>`;
            }
            
            // 金额列之后的填充
            for (let i = 0; i < this.afterAmountColumns; i++) {
              printHTML += `<td></td>`;
            }
            
            printHTML += `</tr>`;
          }
        }
        
        printHTML += `
                </tbody>
              </table>
            </div>
            
            <!-- 页码 -->
            <div class="print-footer">
              第 ${pageIndex + 1} 页 / 共 ${this.totalPages} 页
            </div>
          </div>
        `;
      });

      printHTML += `
          </body>
        </html>
      `;

      // 写入打印文档
      printDoc.open();
      printDoc.write(printHTML);
      printDoc.close();

      // 等待内容加载完成后打印
      printWindow.onload = () => {
        // 添加额外的样式调整，确保内容不溢出
        const style = printDoc.createElement('style');
        style.textContent = `
          /* 最终调整，确保所有内容都在页面内 */
          body { zoom: 0.95; }
          .print-table td, .print-table th { 
            max-width: 150px !important; 
            overflow: hidden !important;
          }
        `;
        printDoc.head.appendChild(style);
        
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
          
          // 打印后关闭窗口
          printWindow.onafterprint = () => {
            setTimeout(() => {
              printWindow.close();
            }, 100);
          };
        }, 500);
      };
    }
  }
};
</script>

<style>
/* 文本元素样式 */
.text-content {
  padding: 4px;
  white-space: pre-wrap;
}

/* 表格样式 - 只在预览时应用列宽 */
.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  /* 只在预览时使用fixed布局 */
  table-layout: fixed;
}

.detail-table th,
.detail-table td {
  border: 1px solid #333;
  padding: 4px 10px;
  text-align: center;
  word-wrap: break-word;
  word-break: break-word; /* 预览时也启用断词 */
}

/* 预览时商品名称和备注列左对齐 */
.detail-table th:nth-child(2),
.detail-table td:nth-child(2),
.detail-table th:last-child,
.detail-table td:last-child {
  text-align: left;
}

.total-row {
  font-size: 14px;
  font-weight: bold;
  background-color: #f0f0f0;
}

.discount-row {
  font-size: 13px;
}

.payment-row {
  font-size: 14px;
  font-weight: bold;
  background-color: #f8f8f8;
}

/* 加载提示 */
.loading-container {
  text-align: center;
  padding: 50px;
  color: #999;
}

.el-icon-loading {
  margin-right: 10px;
}

/* 打印样式优化 */
@media print {
  .el-button,
  .el-select {
    display: none !important;
  }
  
  body {
    zoom: 0.9; /* 稍微缩小整体内容 */
  }
}
</style>


// WEBPACK FOOTER //
// src/views/order/order/genorder.vue